interface ShouldDelayOnboardingRedirectParams {
    profileHasWorkspace: boolean;
    currentWorkspaceId?: string | null;
    isLoadingWorkspaces: boolean;
    pendingPasswordSetup?: boolean;
    pendingWorkspaceReturn?: boolean;
}

export const shouldDelayOnboardingRedirect = ({
    profileHasWorkspace,
    currentWorkspaceId,
    isLoadingWorkspaces,
    pendingPasswordSetup,
    pendingWorkspaceReturn,
}: ShouldDelayOnboardingRedirectParams): boolean => {
    if (profileHasWorkspace) {
        return false;
    }

    if (pendingPasswordSetup) {
        return true;
    }

    if (pendingWorkspaceReturn) {
        return true;
    }

    return isLoadingWorkspaces || Boolean(currentWorkspaceId);
};
